// extracted by mini-css-extract-plugin
export default {"chart":"TrafficChannel_chart__GkyF0","legend":"TrafficChannel_legend__qkz89","indicator":"TrafficChannel_indicator__SW1YO","color":"TrafficChannel_color__DKCU4"};